"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Marks a section of a template to be escaped or not.
 */
const token_parser_1 = require("../token-parser");
const node_1 = require("../node");
const token_1 = require("../token");
const syntax_1 = require("../error/syntax");
const auto_escape_1 = require("../node/auto-escape");
class TwingTokenParserAutoEscape extends token_parser_1.TwingTokenParser {
    parse(token) {
        let lineno = token.getLine();
        let columnno = token.getColumn();
        let stream = this.parser.getStream();
        let value;
        if (stream.test(token_1.TwingToken.BLOCK_END_TYPE)) {
            value = 'html';
        }
        else {
            let expr = this.parser.getExpressionParser().parseExpression();
            if (expr.getType() !== node_1.TwingNodeType.EXPRESSION_CONSTANT) {
                throw new syntax_1.TwingErrorSyntax('An escaping strategy must be a string or false.', stream.getCurrent().getLine(), stream.getSourceContext());
            }
            value = expr.getAttribute('value');
        }
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        let body = this.parser.subparse([this, this.decideBlockEnd], true);
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        return new auto_escape_1.TwingNodeAutoEscape(value, body, lineno, columnno, this.getTag());
    }
    decideBlockEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endautoescape');
    }
    getTag() {
        return 'autoescape';
    }
}
exports.TwingTokenParserAutoEscape = TwingTokenParserAutoEscape;
